import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../utils/supabase';

const WardSelector = () => {
  const [wards, setWards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchWards() {
      try {
        setLoading(true);
        const { data, error } = await supabase
          .from('wards')
          .select('*')
          .order('name');

        if (error) {
          throw error;
        }

        setWards(data || []);
      } catch (error) {
        console.error('Error fetching wards:', error);
        setError('Failed to load wards. Please try again later.');
      } finally {
        setLoading(false);
      }
    }

    fetchWards();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#00bed6]"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4 max-w-md">
          {error}
        </div>
        <button 
          onClick={() => window.location.reload()}
          className="bg-[#00bed6] hover:bg-[#009eb3] text-white font-bold py-2 px-4 rounded"
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center p-4">
      <div className="max-w-4xl w-full">
        <h1 className="text-3xl font-bold text-center my-8 text-[#00bed6]">Road Delivery Planner</h1>
        
        <div className="bg-white rounded-lg shadow-md p-6">
          <h2 className="text-xl font-semibold mb-4">Select Your Ward</h2>
          
          {wards.length === 0 ? (
            <p className="text-center py-4 text-gray-600">No wards available at the moment.</p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {wards.map(ward => (
                <Link 
                  key={ward.id}
                  to={`/deliveryplanner/${ward.slug}`}
                  className="bg-[#f2f2f2] hover:bg-[#e6e6e6] border border-[#00bed6] rounded-lg p-4 text-center transition-colors duration-200"
                >
                  <div className="text-lg font-medium text-[#201f20]">{ward.name}</div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WardSelector;